var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 25",
    clipPath: "url(#clip0_462_2869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4113 17.4261C10.7554 17.8163 7.08837 17.8163 3.43245 17.4261C1.97467 17.2705 0.823236 16.1191 0.667651 14.6612C0.27745 11.0052 0.27745 7.33837 0.667651 3.68245C0.823236 2.22467 1.97467 1.07324 3.43245 0.917651C7.08837 0.52745 10.7552 0.52745 14.4112 0.917651C15.8691 1.07324 17.0205 2.22467 17.1761 3.68245C17.5663 7.33837 17.5663 11.0052 17.1761 14.6612C17.0205 16.1191 15.8692 17.2705 14.4113 17.4261Z",
    fill: "url(#paint0_linear_462_2869)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.17001 17.7149C10.166 17.7101 11.1618 17.6763 12.1573 17.6137V10.6736H14.1393L14.3788 8.17973H12.1573V6.5961C12.1573 6.24633 12.4408 5.9628 12.7906 5.9628H14.3788V3.46875H11.8666C10.3773 3.46875 9.17001 4.67613 9.17001 6.16547V8.17973H7.71875V10.6736H9.17001V17.7149Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_462_2869",
    x1: 6.05045,
    y1: 3.02835,
    x2: 10.3739,
    y2: 12.2786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3457A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5998"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_462_2869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0938,
    height: 17.0938,
    fill: "white",
    transform: "translate(0.375 0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb3);
export default __webpack_public_path__ + "static/media/FB3.e302db332f42e9d36a26620d5db80c40.svg";
export { ForwardRef as ReactComponent };